import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JsonLoaderService {

  constructor(private http: HttpClient) {}
  getJsonData(jsonUrl: string): Observable<any> {
    return this.http.get(jsonUrl);
  }
}
